import { setupRotateFor } from "./rotate";
import { setupGrabFor } from "./grab";
import { random, Unsubs } from "./util";

function main() {
    const params = new URLSearchParams(window.location.search);

    const opt = {
        a: params.has("all") || params.has("a"),
        rotate: params.has("rotate") || random(0, 10) === 0,
        grab: params.has("grab") || random(0, 10) === 0,
    };

    const unsubs = new Unsubs();

    if (opt.a || opt.rotate) {
        unsubs.add(setupRotateFor("h1"));
    }
    if (opt.a || opt.grab) {
        unsubs.add(setupGrabFor("h1"));
    }
}

main();
